import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Getdatos from "../../../services/getDatos";

export default function Dependencias({
  handleChange,
  nameCombo,
  idDependencia,
}) {
  const [dependencias, setDependencias] = useState();

  useEffect(() => {
    async function aux() {
      const data = await Getdatos("atributos/combos");
      setDependencias(data.resultDependencias);
    }
    aux();
  }, []);
  return (
    <>
      <Form.Select
        className="inputs-forms-admin focus-admin-register"
        name={nameCombo}
        value={idDependencia}
        onChange={handleChange}
      >
        <option selected>Seleccione...</option>
        {dependencias
          ? dependencias.map((e, i) => {
              return (
                <option key={e.id_dependencia} value={e.id_dependencia}>{e.nombre}</option>
              );
            })
          : ""}
      </Form.Select>
    </>
  );
}
